import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddRealEstateConditionsMutation, useDeleteRealEstateConditionsMutation, useEditRealEstateConditionsMutation } from "../../../../redux/api/handBooksApi/realEstateConditionsApi";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { getCookie } from "typescript-cookie";

const useRealEstateConditions = (modal: any, refresh?: () => void) => { 
    const { t } = useTranslation();
    const { confirm } = modal;
    const [addRealEstateConditions] = useAddRealEstateConditionsMutation();  
    const [deleteRealEstateConditions] = useDeleteRealEstateConditionsMutation(); 
    const [editRealEstateConditions] = useEditRealEstateConditionsMutation(); 

    async function onAddRealEstateConditions(newRealEstateConditions: EntDirectoryInfoName): Promise<boolean> {  
        try {
            let status: boolean = false;
            await addRealEstateConditions(newRealEstateConditions).then((response: any) => {  
                 if (response.error) {
                                             const isKyrgyz = getCookie('i18next') === 'ky';
                                             const lang = isKyrgyz ? 'kg' : 'ru';
                                             const res = response.error.data?.res;
                                             const errorMessages = Array.isArray(res)
                                                 ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                 : response.error.data?.msg || t('unknownError'); 
                                             throw new Error(errorMessages);
                                         }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteRealEstateConditions(realEstateConditions: EntDirectoryInfoName) {  
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteRealEstateConditions(realEstateConditions.id as number).then((response: any) => {  
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditRealEstateConditions(editedRealEstateConditions: EntDirectoryInfoName): Promise<boolean> {  
        try {
            let status: boolean = false;
            await editRealEstateConditions(editedRealEstateConditions).then((response: any) => {  
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddRealEstateConditions, onDeleteRealEstateConditions, onEditRealEstateConditions };
}

export { useRealEstateConditions };
